import React from "react";
import SidebarStepSlider from '../sliders/SidebarStepSlider.jsx'

import { useRecoilState } from "recoil";
import { layerDefPointSizeSelector } from "../../layers/recoil";

const MAX_POINT_SIZE = 15
const MIN_POINT_SIZE = 3
const STEP_SIZE = 1

export default function PointSizeSlider({ layerID }) {
  const [pointSize, setPointSize] = useRecoilState(
    layerDefPointSizeSelector(layerID)
  );

  if (typeof pointSize !== "number") {
    return null;
  }

  const updatePointSize = (value) => {
    setPointSize(Math.round(value))
  }

  return (
    <SidebarStepSlider
      title="Point size"
      min={MIN_POINT_SIZE}
      max={MAX_POINT_SIZE}
      step={STEP_SIZE}
      value={pointSize}
      updateValue={updatePointSize}
      incrementLabal="Increase the size of points"
      decrementLabal="Decrease the size of points" />
  )
}